import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Elements } from 'react-stripe-elements'
import ReactPixel from 'react-facebook-pixel'
import selectors from '../../../store/shared/selectors'
import NavBar from '../../../components/ui/navigation/NavBar/index'
import withTour from '../../../components/hocs/withTour'
import * as insTokenDuck from './insTokenDuck'
import SelectPlanScreen from './components/SelectPlanScreen'
import PaymentScreen from './components/PaymentScreen'

class OnboardingIndex extends Component {
  static propTypes = {
    clearInsToken: PropTypes.func.isRequired,
    insToken: PropTypes.string,
    organizationName: PropTypes.string,
    queryParams: PropTypes.any.isRequired,
    validateInsToken: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    /**
     * @description Ephemeral component state
     * @type {{selectedPlan: null}}
     */
    this.state = {
      selectedPlan: null,
    }

    this.selectPlan = selectedPlan => {
      this.setState({ selectedPlan })
      if(selectedPlan) ReactPixel.trackCustom(`${selectedPlan}_click`)
    }

    this.clearInsToken = () => this.props.clearInsToken()
  }

  componentWillMount() {
    const { queryParams: { insToken }, validateInsToken } = this.props
    if (insToken) {
      validateInsToken({ insToken }).then(() => {}).catch(() => {})
    }
  }

  componentDidMount() {
    ReactPixel.pageView()
    ReactPixel.track('ViewContent')
  }

  render() {
    const { insToken, organizationName } = this.props
    const { selectedPlan } = this.state

    const readyForInfo = selectedPlan || insToken

    return (
      <div>
        <NavBar />
        <Elements>
          <div>
            {readyForInfo
              ? <PaymentScreen
                  clearInsToken={this.clearInsToken}
                  insToken={insToken}
                  organizationName={organizationName}
                  selectPlan={this.selectPlan}
                  selectedPlan={selectedPlan}/>
              : <SelectPlanScreen selectPlan={this.selectPlan}/>
            }
          </div>
        </Elements>
      </div>
    )
  }
}

/**
 * @const mapStateToProps
 * @param _state
 */
const mapStateToProps = _state => ({
  insToken: insTokenDuck.getValidatedInsToken(_state),
  organizationName: insTokenDuck.getName(_state),
  queryParams: selectors.getQueryStringSimply(_state)
})

/**
 * @const mapDispatchToProps
 * @param dispatch
 */
const mapDispatchToProps = dispatch => bindActionCreators({
  clearInsToken: insTokenDuck.clearInsToken,
  validateInsToken: insTokenDuck.performValidateInsToken,
}, dispatch)

const tourSteps = [
  {
    selector: "#profile-info-card",
    content: "First, help us get to know you with some basic information."
  },
  {
    selector: "#profile-payment-card",
    content: "Then, complete our encrypted, secure checkout with the credit card of your choice. "
  }
]

export default connect(mapStateToProps, mapDispatchToProps)(
  withTour('payment', tourSteps)(OnboardingIndex)
)



// WEBPACK FOOTER //
// ./src/routes/unauthenticated/Onboarding/OnboardingIndex.js